import Vuex from 'vuex'
import Vue from 'vue'

Vue.use(Vuex)

export default new Vuex.Store({
  state: {
    theme: 'light',
    version: '2.0.1',
    valuta: {
      currency: 'DKK'
    },
    monthsShort: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
    monthsLong: ['januar', 'februar', 'marts', 'april', 'maj', 'juni', 'juli', 'august', 'september', 'oktober', 'november', 'december'],
    account: {
      cvr: 'Henter...',
      name: 'Henter...',
      email: 'Henter...',
      phone: 'Henter...',
      address: 'Henter...',
      zipcity: 'Henter...',
      email_verified: 0,
      phone_verified: 0,
    },
    stats: {
      devices: [],
      data: [],
      cpudata: [],
    }
  },

  getters: {
    // Here we will create a getter
  },

  mutations: {
    // Here we will create Jenny
  },

  actions: {
    setProducts(state, data) {
      state.products = data;
    }
    // Here we will create Larry
  }
});